<template>
  <ElDrawer
    v-model="visible"
    append-to-body
    direction="btt"
    modal-class="guide-popup"
    size="auto"
  >
    <div class="guide-popup-content">
      <div class="guide-title">
        {{ $t('uninstall-app-tip') }}
      </div>
      <InstallChannelsList
        :install-channels="installChannels.slice(0, isIos ? 1 : 2).filter(i => !i.hide)"
        @click="handleInstallChannelClick"
      />
      <div
        class="guide-tip"
        @click="handleOpen"
      >
        {{ $t('installed-app') }} >
      </div>
    </div>
  </ElDrawer>
</template>

<script
  lang="ts"
  setup
>
import { ref } from '#imports'
import InstallChannelsList from '@/components/InstallChannelsList.vue'
import useInstallChannels from '@/composables/useInstallChannels'
import track, {
  type OpenAppButtons,
  type Systems,
} from '@/track/webShare'
import {
  isAndroid,
  isIOS,
} from '@/utils'

interface EmitEvent {
  (e: 'toApp'): void
}

const emits = defineEmits<EmitEvent>()

const isIos = isIOS()
const installChannels = useInstallChannels('webshare')
const visible = ref(false)

const getSystem = () => {
  let system = 'other'
  if (isAndroid()) system = 'android'
  else if (isIos) system = 'ios'
  return system as Systems
}

const show = () => {
  visible.value = true
  track.web_share_open_app_pop_show({ system: getSystem() })
}

const hide = () => {
  visible.value = false
}

const handleInstallChannelClick = (item: typeof installChannels.value[0]) => {
  const { trackEventButtonParameter: type } = item
  let button: OpenAppButtons = 'download_apk'
  if (type === 'google') button = 'to_googleplay'
  else if (type === 'app_store') button = 'to_appstore'
  track.web_share_open_app_pop_click({ system: getSystem(), button })
}

const handleOpen = () => {
  emits('toApp')
  track.web_share_open_app_pop_click({ system: getSystem(), button: 'open_directly' })
}

defineExpose({ show, hide })
</script>

<style lang="less">
.guide-popup {
  .el-drawer {
    border-radius: 16px 16px 0 0;

    &__header {
      margin-bottom: 0px;
    }

    &__body {
      padding: 16px;
    }
  }

  &-content {
    padding-bottom: 30px;
    text-align: center;

    .guide-title {
      font-weight: 600;
      font-size: 18px;
      line-height: 27px;
      text-align: center;
      letter-spacing: -0.72px;
      color: var(--color-primary-text);
    }

    .install-channels {
      margin-top: 24px;
    }

    .guide-tip {
      color: var(--color-primary);
    }
  }
}
</style>
